package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.clickable
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color

@Composable
fun ToolbarTextButton(
    text: String,
    modifier: Modifier = Modifier,
    buttonColors: ButtonColors = buttonColors(),
    enabled: Boolean = true,
    onClick: () -> Unit,
) {
    val textColor = if (enabled) {
        Color.White
    } else {
        Color.White.copy(alpha = 0.38f) // סטנדרט Material ל-disabled
    }

    Text(
        text = text,
        color = textColor,
        modifier = modifier
            .clickable(
                enabled = enabled,
                onClick = onClick,
            ),
    )
}

@Composable
fun buttonColors(
    backgroundColor: Color = Color.Transparent,
    contentColor: Color = MaterialTheme.colorScheme.primary,
    disabledBackgroundColor: Color = Color.Transparent,
    disabledContentColor: Color = Color.Unspecified,
): ButtonColors = ButtonDefaults.buttonColors(
    containerColor = backgroundColor,
    contentColor = contentColor,
    disabledContainerColor = disabledBackgroundColor,
    disabledContentColor = disabledContentColor,
)
